export const whatsApp = {
    'VERSION': 'v16.0',
    'PHONE_NUMBER_ID' : '107287678965552',
    'ACCESS_TOKEN' : 'EAABtPfqQEJ0BAGLwjcos2nyZAaptYdOdPAoZBig7xgkZC82x10w72Fzw7xna1TAJ7YCG86ZAg9Vf083i2eSpSRBtlp4cZBZB1bvrZBEEhBNbe4GoMc6YHiHZAlivhzOkZAIv8c8bjHZAszqdZBIIGuGM9smQ6MZCZAtvbUUNKGqrlK6GWMSqFyfH3iLA0ZAPHlMfxTGYJJb41bPkbmwAZDZD',
    'contacts': ['917036784473','6300911141','7993874018'],
    'server':'DEV DATA'
}
export default whatsApp;